import queryString from 'query-string';

const LOCALHOST = ['localhost', '127.0.0.1'];

export const hasParameters = (urlParams) => {
  const requiredParamNames = ['client_id', 'redirect_uri'];

  return urlParams && requiredParamNames.filter((name) => urlParams[name]).length === requiredParamNames.length;
};

export const isValidReturnUrl = (urlParams) => {
  const redirectUrl = urlParams.redirect_uri;
  if (!redirectUrl) {
    return null;
  }

  const isValid = LOCALHOST.filter((i) => redirectUrl.includes(i)).length === 0;
  return isValid;
};

export const getReturnUrl = (username, urlParams) => {
  if (!hasParameters(urlParams)) {
    return null;
  }

  const isValid = isValidReturnUrl(urlParams);
  const returnUrl = isValid && getRedirectLoginUrl(username, urlParams);

  return returnUrl;
};

const getRedirectLoginUrl = (username = 'helloworld', urlParams) => {
  const paramsConfig = {
    ...urlParams,
    prompt: 'login',
    login_hint: `KR|${username}`
  };
  delete paramsConfig.acr_values;

  return `${process.env.REACT_APP_RSO_AUTHORIZE_URL}?${queryString.stringify(paramsConfig)}`;
};
